module.exports = __webpack_public_path__ + "img/04-424-424.d7a7bc7c.png";